module.exports = __webpack_public_path__ + "static/scale-model-of-blue-valley-park-sprayground-in-kansas-city-missouri-82fffee9466dc47c3f8cf20d87a7bbb9.png";